module.exports = __webpack_public_path__ + "img/img05.45c652e9.jpg";